import {Component, ContentChild,  ElementRef, HostListener, OnInit, TemplateRef, ViewChild} from '@angular/core';

@Component({
  selector: 'exg-lane',
  templateUrl: './exg-lane.component.html',
  styleUrls: ['./exg-lane.component.css']
})
export class ExgLaneComponent implements OnInit {

  @ViewChild('container') viewport!: ElementRef;
  @ViewChild('containercontent') scene!: ElementRef;
  @ContentChild('content') content?: TemplateRef<ElementRef>;



  ViewChecked = false; // ein neuer Annsatz um Consolenfehler zu vermeiden, wenn DOM Zugrif benötigt wird, hier Bsp. maxScroll

  scroll = 0;

  constructor() {
  }

  get style(): string {
    return `transform: translate(${this.scroll}px,0);`;
  }

  get maxScroll(): number {
    if (!this.viewport || !this.scene) {
      return 0;
    }
    const viewport = (this.viewport.nativeElement as Element).getBoundingClientRect();
    const sceneWidth = (this.scene.nativeElement as Element).scrollWidth;
    return sceneWidth * -1 + viewport.width - 8;
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.ViewChecked = true;
    }, 10);
  }


  setScrollLimit(): void {
    if (this.scroll < this.maxScroll) {
      this.scroll = this.maxScroll;
    }
    if (this.scroll > 0) {
      this.scroll = 0;
    }
  }

  onWheel(e: WheelEvent): void {

    e.preventDefault();

    this.scroll = this.scroll + e.deltaY;
    this.setScrollLimit();

  }

  moveScene(direction: number = -1): void {

    const viewport = (this.viewport.nativeElement as Element).getBoundingClientRect();

    this.scroll = this.scroll - viewport.width * direction;

    this.setScrollLimit();
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.setScrollLimit();
  }


}
